import { serializable, primitive, object, alias } from 'serializr';

class Infographics {
  @serializable(alias('km_driven', primitive()))
  kmDriven?: number;

  @serializable(alias('electricity_used', primitive()))
  electricityUsed?: number;

  @serializable(alias('smartphones_charged', primitive()))
  smartphonesCharged?: number;

  @serializable(alias('trees_grown', primitive()))
  treesGrown?: number;
}

export class InfoDataModel {
  @serializable(object(Infographics))
  infographics?: Infographics;
}
